module.exports = {"522322001":"东湖街道","522322002":"城南街道","522322003":"真武山街道","522322004":"城北街道","522322101":"屯脚镇","522322102":"巴铃镇","522322103":"百德镇","522322104":"雨樟镇","522322105":"潘家庄镇","522322106":"回龙镇","522322107":"下山镇","522322108":"新龙场镇","522322109":"大山镇","522322110":"马马崖镇","522322111":"波阳镇","522322205":"鲁础营回族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/522322.json
// module id = 2503
// module chunks = 0